import { Component, Input, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';
import { BarVertical2DComponent, BarOrientation } from '@swimlane/ngx-charts';
import { trigger, transition, style, animate } from '@angular/animations';

export interface ReferenceLine {
  label: string;
  value: number;
  color?: string;
}

@Component({
  selector: 'app-bar-vertical-2d-ref-lines',
  templateUrl: './bar-vertical-2d-ref-lines.component.html',
  styleUrls: ['./bar-vertical-2d-ref-lines.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('animationState', [
      transition(':leave', [
        style({ opacity: 1, transform: '*' }),
        animate(500, style({ opacity: 0, transform: 'scale(0)' }))
      ])
    ])
  ]
})
export class BarVertical2dRefLinesComponent extends BarVertical2DComponent {
  @Input() referenceLines: ReferenceLine[] = [];

  activeRefLine: ReferenceLine | null = null;
  tooltipX = 0;
  tooltipY = 0;

  readonly barOrientationRef = BarOrientation;

  onRefLineMouseEnter(event: MouseEvent, refLine: ReferenceLine): void {
    this.activeRefLine = refLine;
    this.tooltipX = event.clientX;
    this.tooltipY = event.clientY;
  }

  onRefLineMouseMove(event: MouseEvent): void {
    this.tooltipX = event.clientX;
    this.tooltipY = event.clientY;
  }

  onRefLineMouseLeave(): void {
    this.activeRefLine = null;
  }
}
